export interface TeamScopedQueryOptions {
  teamId?: string | null;
  enabled?: boolean;
}

export function normalizeTeamScopedQueryOptions(options: TeamScopedQueryOptions = {}) {
  return {
    teamId: options.teamId ?? null,
    enabled: options.enabled ?? true,
  };
}

export function isUserQueryEnabled(userId: string | undefined, enabled: boolean): boolean {
  return Boolean(userId) && enabled;
}
